import { useSelector } from "react-redux";
import { THEMES } from "../../theme/global/constants";
import Loader from "./index";
import React from "react";
import PropTypes from "prop-types";

export const LoadingStubber = ({children}) => {
  const themeName = useSelector(state => state.StartUp.theme);

  if (themeName === THEMES.loading) {
    return <Loader />;
  }

  return <>{children}</>;
};

LoadingStubber.propTypes = {
  children: PropTypes.node,
};
